// extracted by mini-css-extract-plugin
export default {"lastBreadcrumbItem":"hz-layouts-auth-layout-components-page-header-components-content-header-components-breadcrumb-header-index-lastBreadcrumbItem"};